let IS_PROD = true;

const server = IS_PROD ?
    "https://backend-x3k2.onrender.com" :
    
    "http://localhost:8000"


export default server;
